import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The following table discusses the component types that Commerce Marketplace supports. The composer `}<inlineCode parentName="p">{`type`}</inlineCode>{` column in the following table specifies the value of the `}<inlineCode parentName="p">{`type`}</inlineCode>{` field you must add to `}<inlineCode parentName="p">{`composer.json`}</inlineCode>{` for that type of component.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Friendly name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`composer.json type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Metapackage`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`metapackage`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Technically, a Composer package type, not a Magento component type. A metapackage consists of only a `}<inlineCode parentName="td">{`composer.json`}</inlineCode>{` file that specifies a list of components and their dependencies. For example, both Magento Open Source and Adobe Commerce are metapackages.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Module`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`magento2-module`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Code that modifies application behavior. You can upload a single module to the Commerce Marketplace or your module can be dependent on some parent package.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Theme`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`magento2-theme`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Code that modifies the look and feel of the storefront or Admin.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Language package`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`magento2-language`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Translations for the storefront or Admin.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Library`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`magento2-library`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Support for libraries located in `}<inlineCode parentName="td">{`lib/internal`}</inlineCode>{` instead of in the `}<inlineCode parentName="td">{`vendor`}</inlineCode>{` directory.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Component`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`magento2-component`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The package formed of the files that must be located in root (.htaccess, etc). This includes `}<inlineCode parentName="td">{`dev/tests`}</inlineCode>{` and `}<inlineCode parentName="td">{`setup`}</inlineCode>{` as well for now.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      